<!-- svelte-ignore a11y-missing-attribute -->
<li class:is-active={$isActive('./' + page)} on:click={$goto('./' + page)}><a>{label}</a></li>

<script lang="ts">
  export let page :string;
  export let label :string;

  import { isActive, goto } from '@sveltech/routify';
</script>